
















































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarTimeHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  name: 'CheckboxGrid';
  checked: true;
  async getSubStreamHowen() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraSubStreamHowen'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getBasic() {
    this.ordesList2 = (await this.getSubStreamHowen()) || [];
    this.data = this.ordesList2[0];
    this.formFields.resolution.value = parseInt(
      this.data['?column?'].Resolution
    );
    this.formFields.frameRate.value = parseInt(this.data['?column?'].FrameRate);
    this.formFields.quality.value = parseInt(this.data['?column?'].Quality);
  }
  mounted() {
    this.getBasic();
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    resolution: any;
    frameRate: any;
    quality: any;
  } = {
    resolution: {
      label: 'Resolution',
      value: 0,
      items: [
        { label: 'HD1080', id: 0 },
        { label: 'HD720', id: 1 },
        { label: 'VGA', id: 2 },
        { label: 'D1', id: 3 },
        { label: 'HD1', id: 4 },
        { label: 'CIF', id: 5 },
        { label: 'WD1', id: 6 },
      ],
    },
    frameRate: {
      label: 'Frame Rate',
      value: 0,
      items: [
        { label: '1', id: 1 },
        { label: '2', id: 2 },
        { label: '2', id: 2 },
        { label: '3', id: 3 },
        { label: '4', id: 4 },
        { label: '5', id: 5 },
        { label: '6', id: 6 },
        { label: '7', id: 7 },
        { label: '8', id: 8 },
        { label: '9', id: 9 },
        { label: '10', id: 10 },
        { label: '11', id: 11 },
        { label: '12', id: 12 },
        { label: '13', id: 13 },
        { label: '14', id: 14 },
        { label: '15', id: 15 },
        { label: '16', id: 16 },
        { label: '17', id: 17 },
        { label: '18', id: 18 },
        { label: '19', id: 19 },
        { label: '20', id: 20 },
        { label: '21', id: 21 },
        { label: '22', id: 22 },
        { label: '23', id: 23 },
        { label: '24', id: 24 },
        { label: '25', id: 25 },
        { label: '26', id: 26 },
        { label: '27', id: 27 },
        { label: '28', id: 28 },
        { label: '29', id: 29 },
        { label: '30', id: 30 },
      ],
    },
    quality: {
      label: 'Quality',
      value: 0,
      items: [
        { label: '0', id: 0 },
        { label: '1', id: 1 },
        { label: '2', id: 2 },
        { label: '3', id: 3 },
        { label: '4', id: 4 },
        { label: '5', id: 5 },
        { label: '6', id: 6 },
        { label: '7', id: 7 },
      ],
    },
  };
  selectedResolution() {
    return this.formFields.resolution.items.find(
      (item: { id: any }) => item.id === this.formFields.resolution.value
    );
  }
  selectedFrameRate() {
    return this.formFields.frameRate.items.find(
      (item: { id: any }) => item.id === this.formFields.frameRate.value
    );
  }
  selectedQuality() {
    return this.formFields.quality.items.find(
      (item: { id: any }) => item.id === this.formFields.quality.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
